import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Enregistrement from "./Enregistrement";
import AddContact from "./AddContact";
import { secondsToMilliseconds } from "date-fns";
import { cibOpenCollective } from "@coreui/icons";
import { PlayIcon } from "@heroicons/react/outline";
import ReactTooltip from "react-tooltip";
import ContactProfile from "./ContactProfile";
import CollegueProfile from "./CollegueProfile";
import { withTranslation } from "react-i18next";
import { Context } from "../../themeContext";

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const postemaster = localStorage.getItem("posteMaster");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;

function Journalbox(props) {
  const { t, tReady } = props;
  const tabcol2 = localStorage.getItem("tabcollegue");
  const tabcol = JSON.parse(tabcol2);
  const tabcontact2 = localStorage.getItem("tabcontact");
  const tabcontact = JSON.parse(tabcontact2);
  let Name = "";
  let typenum = "";
  let infocoll = new Object();
  let infocontact = new Object();
  let numero = "";
  const [stateObject, dispatch] = useContext(Context);

  const [showMoprofile, setshowprofile] = useState(false);
  const setshowprofilefunction = () => {
    setshowprofile(true);
  };
  const sethideprofilefunction = () => {
    setshowprofile(false);
  };
  const [showcollegue, setshowcollegue] = useState(false);
  const setshowcolleguefunction = () => {
    setshowcollegue(true);
  };
  const sethidecolleguefunction = () => {
    setshowcollegue(false);
  };

  const upper = (nom) => {
    return nom.toUpperCase();
  };
  /************************************Date en 11/11/1111************************* */
  const formatDate = (dateString) => {
    var allDate = dateString.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("-");

    var suffix = thisTime[0] >= 12 ? "PM" : "AM";
    var hour = thisTime[0] > 12 ? thisTime[0] - 12 : thisTime[0];
    var Datefinal = " Le" + newDate + " " + "à" + " " + allDate[1];
    return Datefinal;
  };

  const today = (dateString) => {
    let today = new Date(dateString).setHours(0, 0, 0, 0);
    let yesterday = new Date();
    let yesterdayoftoday = yesterday.setDate(yesterday.getDate() - 1);

    let yesterday2 = new Date(yesterdayoftoday).setHours(0, 0, 0, 0);

    let d2 = new Date(dateString);
    let d1 = new Date();
    let d11 = d1.setHours(0, 0, 0, 0);

    let d22 = d2.setHours(0, 0, 0, 0);

    if ((d11.valueOf() == d22.valueOf()) == true) {
      var allDate = dateString.split(" ");
      var Datefinal = t("aujourdhui") + t("at") + " " + allDate[1];
      return Datefinal;
    }
    if ((yesterday2.valueOf() == today.valueOf()) == true) {
      var allDate = dateString.split(" ");
      var Datefinal = t("hier") + t("at") + " " + allDate[1];
      return Datefinal;
    } else {
      var allDate = dateString.split(" ");
      var thisDate = allDate[0].split("-");
      var thisTime = allDate[1].split(":");
      var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");

      var suffix = thisTime[0] >= 12 ? "PM" : "AM";
      var hour = thisTime[0] > 12 ? thisTime[0] - 12 : thisTime[0];
      var Datefinal = t("le") + newDate + " " + t("at") + " " + allDate[1];
      return Datefinal;
    }
  };
  ////**********************************etat d'appel icons**************** */
  const icon = (disposition, src, dst) => {
    if (src === poste || src === postemaster) {
      if (disposition === "ANSWERED") {
        return (
          <div data-tip data-for="émis1">
            <ReactTooltip id="émis1" place="bottom" effect="solid">
              <div> {t("appelemis")}</div>
            </ReactTooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-blue-500 dark:text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
          </div>
        );
      } else if (disposition === "NO ANSWER") {
        return (
          <div data-tip data-for="émis2">
            <ReactTooltip id="émis2" place="bottom" effect="solid">
              <div>
                {" "}
                {t("appelemis")} , {t("ringing")} {props.person.ringingsec} sec
              </div>
            </ReactTooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-400 dark:text-blue"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
          </div>
        );
      } else {
        return (
          <div data-tip data-for="échoué">
            <ReactTooltip id="échoué" place="bottom" effect="solid">
              <div> {t("failedcall")}</div>
            </ReactTooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
          </div>
        );
      }
    }

    if (src !== poste || src !== postemaster) {
      if (disposition === "ANSWERED") {
        return (
          <div data-tip data-for="recu">
            <ReactTooltip id="recu" place="bottom" effect="solid">
              {t("appelrecu")}
            </ReactTooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
          </div>
        );
      } else {
        return (
          <div data-tip data-for="manqué">
            <ReactTooltip id="manqué" place="bottom" effect="solid">
              {t("appel.manque")}
            </ReactTooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-red-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
          </div>
        );
      }
    }
  };

  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showModal2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [nom, SetNom] = useState("");
  //const [numero, Setnumero] = useState("");

  function classeselect() {
    if (props.genre == "absence_interne" && props.person.genre_appel == "0") {
      const a = "bg-green-700 dark:bg-gray-900 dark:text-white transition-al";
      return a;
    } else {
      const a = "dark:bg-gray-900 dark:text-white transition-al";
      return a;
    }
  }

  const appel = (collegue) => {
    if (
      (collegue.src == poste && tabcol !== null) ||
      collegue.src == postemaster
    ) {
      numero = collegue.dst;
      return <div class="text-sm leading-5 text-gray-500">{collegue.dst}</div>;
    } else {
      numero = collegue.src;
      return <div class="text-sm leading-5 text-gray-500">{collegue.src}</div>;
    }
  };
  useEffect(() => {}, [tabcol, tabcontact]);

  const fetchUsers = (collegue) => {
    // if (tabcol !== null) {
    if (
      (collegue.src == poste && tabcol !== null) ||
      (collegue.src == postemaster && tabcol !== null)
    ) {
      const lowercasedValue = collegue.dst;
      for (var i = 0; i < tabcol.length; i++) {
        if (tabcol[i].poste == lowercasedValue) {
          Name = tabcol[i].nom;
          typenum = "profile";
          infocoll = tabcol[i];
        }
      }
    } else {
      const lowercasedValue = collegue.src;
      for (var i = 0; i < tabcol.length; i++) {
        if (tabcol[i].poste === lowercasedValue) {
          Name = tabcol[i].nom;
          typenum = "profile";
          infocoll = tabcol[i];
        }
      }
    }
  };
  const fetchUserscontact = (collegue) => {
    if (tabcontact !== null) {
      if (
        (collegue.src == poste && tabcol !== null) ||
        (collegue.src == postemaster && tabcontact !== null)
      ) {
        const lowercasedValue = collegue.dst;
        for (let j = 0; j < tabcontact.length; j++) {
          if (
            tabcontact[j].tel_portable == lowercasedValue ||
            tabcontact[j].tel_fix == lowercasedValue ||
            tabcontact[j].tel_3 == lowercasedValue ||
            tabcontact[j].tel_4 == lowercasedValue ||
            tabcontact[j].tel_5 == lowercasedValue
          ) {
            Name = tabcontact[j].nom_prenom + " " + tabcontact[j]?.prenom;
            // console.log();
            typenum = "contact";
            infocontact = tabcontact[j];
            // console.log(infocontact);
          }
        }
      } else {
        const lowercasedValue = collegue.src;
        for (let index = 0; index < tabcontact.length; index++) {
          if (
            tabcontact[index].tel_portable == lowercasedValue ||
            tabcontact[index].tel_fix == lowercasedValue ||
            tabcontact[index].tel_3 == lowercasedValue ||
            tabcontact[index].tel_4 == lowercasedValue ||
            tabcontact[index].tel_5 == lowercasedValue
          ) {
            Name =
              tabcontact[index].nom_prenom + " " + tabcontact[index]?.prenom;
            typenum = "contact";
            infocontact = tabcontact[index];
            // console.log(infocontact);
          }
        }
        // console.log("heres  is the name", Name);
      }
    }
  };
  const Playiconsdisabled = (idenregistrement) => {
    if (idenregistrement === "") {
      return (
        <div
          data-tip
          data-for="playTip"
          class="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
        >
          <ReactTooltip id="playTip" place="bottom" effect="solid">
            {t("pasenregistrement")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-300 dark:text-gray-700"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      );
    } else {
      return (
        <button
          data-tip
          data-for="play2Tip"
          type="button"
          onClick={handleShow}
          class="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
        >
          <ReactTooltip id="play2Tip" place="bottom" effect="solid">
            {t("ecouter")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 dark:text-white"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      );
    }
  };
  return (
    <tr className="dark:bg-gray-900 dark:text-white transition-al">
      {/* <tr
    //   className={
    //     props.genre == "absence_interne" && props.person.genre_appel == "0"
    //       ? "bg-nonlu dark:bg-gray-900 dark:text-white transition-al"
    //       : "dark:bg-gray-900 dark:text-white transition-al"
    //   }
    // > */}

      <td class="px-4 py-4 whitespace-no-wrap border-b border-gray-200  dark:border-gray-700 ">
        <div>
          {icon(props.person.disposition, props.person.src, props.person.dst)}
        </div>

        <Enregistrement
          showModal={showModal}
          handleClose={handleClose}
          enregistrement={props.person.id_enregistrement}
        />
        <ReactTooltip id="callTip" place="bottom" effect="solid">
          {t("Appeler")}
        </ReactTooltip>
      </td>
      <td class="px-6 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700 ">
        <div class="flex items-center">
          <div class="flex-shrink-0 h-10 w-10">
            <span class="inline-block relative">
              {fetchUsers(props.person)}
              {fetchUserscontact(props.person)}
              {Name ? (
                <span class="dark:bg-gray-700 inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-400 ">
                  <span class="text-lg font-medium leading-none text-white ">
                    {upper(Name[0])}
                  </span>
                </span>
              ) : (
                <span className="dark:bg-gray-700 inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-200">
                  <svg
                    className="h-full w-full text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                  </svg>
                </span>
              )}
            </span>
          </div>
          <div class="ml-4">
            <div class="text-sm leading-5 font-medium text-gray-900 dark:bg-gray-900 dark:text-white transition-al ">
              {Name}
              {appel(props.person)}
            </div>
          </div>
        </div>
      </td>
      <td class="px-6 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div class="text-sm leading-5 text-gray-500 ml-2 inline-block dark:text-gray-300">
          {today(props.person.calldate_start)}
        </div>
      </td>
      <td class="px-6 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <span class="dark:bg-gray-600 dark:text-white px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
          {props.person.billsec}
        </span>
      </td>
      <td class="px-6 py-3 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium dark:border-gray-700">
        <div class="space-x-3 flex">
          <button
            data-tip
            data-for="callTip"
            type="button"
            onClick={() => {
              dispatch({
                type: "MAKE_CALL",
                payload: {
                  type: "CALL",
                  number:
                    props.person?.dst === poste
                      ? props.person?.src
                      : props.person?.dst,
                  nom: Name,
                  image: "",
                },
              });
            }}
            class="dark:bg-gray-600 inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 dark:text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
          </button>
          {Playiconsdisabled(props.person.id_enregistrement)}

          {/* {console.log(
            "hihihihihihihihiihihihih",
            Object.keys(infocoll).length
          )}{" "}
          {console.log("contactttttt", Object.keys(infocontact).length)}{" "} */}

          {Object.keys(infocoll).length == 0 ? (
            <div class="inline-flex">
              {" "}
              {infocontact === undefined ||
              Object.keys(infocontact).length === 0 ? (
                <div class="inline-flex">
                  {" "}
                  <button
                    type="button"
                    onClick={handleShow2}
                    class="dark:bg-gray-600 inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-gray-500 bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                  >
                    <AddContact
                      showModal={showModal2}
                      handleClose={handleClose2}
                      numero={numero}
                      toggle={props.toggle}
                    />

                    {Name !== "" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 dark:text-white"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 dark:text-gray-300 "
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                      </svg>
                    )}
                  </button>
                </div>
              ) : (
                <button
                  data-tip
                  data-for="infoTipcontact"
                  type="button"
                  onClick={setshowprofilefunction}
                  className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 dark:text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <ReactTooltip
                    id="infoTipcontact"
                    place="bottom"
                    effect="solid"
                  >
                    {t("voircontactprofil")}
                  </ReactTooltip>
                  <ContactProfile
                    show={showMoprofile}
                    close={sethideprofilefunction}
                    collegue={infocontact}
                  />
                </button>
              )}
            </div>
          ) : (
            <button
              data-tip
              data-for="infoTipcollg"
              type="button"
              onClick={setshowcolleguefunction}
              className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 dark:text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <ReactTooltip id="infoTipcollg" place="bottom" effect="solid">
                {t("voircollgprofil")}
              </ReactTooltip>
              <CollegueProfile
                show={showcollegue}
                close={sethidecolleguefunction}
                collegue={infocoll}
              />
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}
export default withTranslation("common")(Journalbox);
